import React, { Component } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { FaExclamationCircle, FaExclamationTriangle } from "react-icons/fa";
import Theme from "../../utils/Theme";
import { FormattedMessage } from "react-intl";
import LoadingIndicator from "../../components/LoadingIndicator";

const StyledContainer = styled.div`
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  position: fixed;
  overflow-y: hidden;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

const StyledContent = styled.div`
  max-width: 500px;
  height: auto;
  width: 90vw;
  background: #fff;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  overflow-y: scroll;
  border-radius: 1em;
`;

const StyledIcon = styled.div`
  color: red;
  font-size: 70px;
  padding-top: 20px;
`;

const StyledHeader = styled.h2`
  color: #000;
`;

const StyledDetails = styled.span`
  font-size: 1em;
  line-height: 1.5em;
  padding: 10px;
`;

const StyledGotItBtn = styled.div`
  border-radius: 25px;
  width: 50%;
  color: white;
  background: ${Theme.PrimaryColor};
  text-transform: uppercase;
  padding: 15px 0;
  margin-bottom: 10%;
  cursor: pointer;
`;

class SelectionWarningModal extends Component {
  onWarningOkayClicked = () => {
    const { onWarningOkayClicked } = this.props;
    onWarningOkayClicked();
  };

  render() {
    const { showWarning, status } = this.props;
    return status ? (
      showWarning ? (
        <StyledContainer>
          <StyledContent>
            <StyledIcon>
              <FaExclamationTriangle />
            </StyledIcon>
            <StyledHeader>
              <FormattedMessage
                id={"warning.header"}
                default={"Are You Sure?"}
              />
            </StyledHeader>
            <StyledDetails>
              <FormattedMessage
                id={"warning.details"}
                default={"Selected Data Will Be Reset, If Change the Page Now."}
              />
            </StyledDetails>
            <StyledGotItBtn onClick={this.onWarningOkayClicked}>
              <FormattedMessage id={"warning.okay.button"} default={"Okay"} />
            </StyledGotItBtn>
          </StyledContent>
        </StyledContainer>
      ) : null
    ) : null;
  }
}

SelectionWarningModal.propTypes = {
  history: PropTypes.object.isRequired,
  showWarning: PropTypes.bool,
  status: PropTypes.bool,
  loading: PropTypes.bool,
  onWarningOkayClicked: PropTypes.func
};

export default SelectionWarningModal;



// WEBPACK FOOTER //
// ./src/components/SelectionWarningModal/index.js